var _defs, _path, _rect, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _rect2, _line, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyle901(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-216,.cls-215,.cls-213{fill:#fff;}.cls-216,.cls-215,.cls-214,.cls-213{stroke:#000;stroke-miterlimit:10;}.cls-216{stroke-width:3px;}.cls-214{fill:none;}.cls-213{stroke-width:1.98px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M96.48,407.29l37.41,8.27A105.9,105.9,0,0,1,165,427.88l46.52,27.64c1.21-41-3.22-92.31,0-124.51,7.06-71.4-.53-147.62-1.42-219.45-4.32.47-23.4,2.08-39.57-11.1A51,51,0,0,1,156,81.15l-44.86,23.79-2,1.08h-.06l-.27.14v1.67q.93,2.64,1.72,5.42c8.68,30.12,7.16,70.74.81,75.71a17.56,17.56,0,0,1-7.45,3.67,44.26,44.26,0,0,1-5.25.76h-.26l-1.39.12c.59,2.23,1.15,4.49,1.66,6.79q1.86,8.37,3.15,17.37c2.48,17.22,3.59,36.29,4.36,57.52C108.26,335,105.61,373.4,96.48,407.29Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 110.62,
    y: 313.82,
    width: 56.76,
    height: 4.41
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M167,68.45a10.59,10.59,0,0,0-1.19,5c.2,9.6,15.13,18.82,36.67,23.78.19,4.56.69,10.11.89,14.67-2.85-.78-25.42-.36-35.17-12.69-1.75-2.21-5.25-4.88-7.56-8.58-1.16-1.87-4.69-4.77-4.39-9,.33-4.48,4.35-8,5.42-9.26A18.85,18.85,0,0,1,167,68.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M242.05,68.45a10.59,10.59,0,0,1,1.19,5C243,83,228.1,92.23,206.57,97.19c-.19,4.56-.69,10.11-.89,14.67,2.85-.78,25.42-.36,35.17-12.69,1.75-2.21,5.25-4.88,7.55-8.58,1.17-1.87,4.7-4.77,4.4-9-.33-4.48-4.35-8-5.42-9.26A18.72,18.72,0,0,0,242.05,68.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M314.53,416.77l-13.21.09C229.25,411.67,178,403.44,144,339.67c.9-68,4.91-144.42,0-218.67,4.32.47,67.67,1.41,96.5-20.55A51,51,0,0,0,255,81.15l44.86,23.79,2.05,1.08H302l.27.14v1.67c-.62,1.76-1.19,3.56-1.71,5.42-8.68,30.12-7.17,70.74-.81,75.71a17.56,17.56,0,0,0,7.45,3.67,44,44,0,0,0,5.25.76h.26l1.39.12q-.88,3.35-1.66,6.79-1.86,8.37-3.15,17.37c-2.48,17.22-3.59,36.29-4.36,57.52C302.71,335,305.36,382.46,314.53,416.77Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 313.82,
    r: 5.66
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 268.28,
    r: 5.66
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 131.65,
    r: 5.66
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 177.19,
    r: 5.66
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 222.73,
    r: 5.66
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 241.9,
    y: 313,
    width: 56.76,
    height: 4.41
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-214",
    x1: 261.22,
    y1: 232.28,
    x2: 259.33,
    y2: 313
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "275.38 173.83 232.95 173.83 236.25 163.5 278.68 163.5 275.38 173.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle901);
export default __webpack_public_path__ + "static/media/STYLE 9-01.b10d691fd0e8086a73d93a91b8a61a8d.svg";
export { ForwardRef as ReactComponent };